
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

@Component({
	components: {
		vSelect,
	},
})
export default class CurrencyInput extends Vue {
	@Prop({ default: () => ['CAD'] })
	currencies!: string[];
	@Prop({ default: '' }) name!: string;
	@Prop({ default: '' }) containerClass!: string;
	@Prop({ default: '' }) selectClass!: string;
	@Prop({ default: '' }) inputClass!: string;

	@Model('input', { default: '' }) readonly value!: string;
	@Model('update:currency', { default: '' })
	readonly selectedCurrency!: string;

	get innerValue() {
		return this.value;
	}

	get innerSelectedCurrency() {
		return this.selectedCurrency;
	}
	emitBlur() {
		this.$emit('blur');
	}

	onInput(event: Event) {
		const inputValue = (event.target as HTMLInputElement).value;

		if (/^\d*\.?\d*$/.test(inputValue)) {
			this.$emit('input', inputValue);
		} else {
		this.$emit('input', '');
		}
	}
	emitCurrency(value: string) {
		this.$emit('update:currency', value);
	}
}
